export default function ChatgptCoverLetter() {
  return <h2>Chatgpt Cover Letter</h2>;
}
